import { IPortfolioCity, IPortfolioRegion } from '@api'
import { findIndex } from 'lodash'
import { MutableRefObject, useEffect, useRef } from 'react'

type UseLocationListScroll = (
  cityNav: IPortfolioCity | null,
  regions: IPortfolioRegion[]
) => MutableRefObject<HTMLDivElement | null>

export const useLocationListScroll: UseLocationListScroll = (cityNav, regions) => {
  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!cityNav) return
    let i = 0
    for (const region of regions) {
      const index = findIndex(region.cities, (c) => cityNav.name === c.name)
      i = i + (index === -1 ? region.cities.length : index + 1)
      if (index !== -1) break
    }
    if (i >= 0 && listRef.current) {
      const offset = i * 31
      if (offset < listRef.current.scrollTop || offset > listRef.current.scrollTop + 260) {
        listRef.current.scrollBy(0, i * 31 - listRef.current.scrollTop)
      }
    }
  }, [cityNav, regions])

  return listRef
}
